import React, {Component} from 'react';
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import FormField from "../../../../../Utils/Form/Fields/FormField";
import withStyles from "@material-ui/core/styles/withStyles";
import TypeEntity from "../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";

const styles = () => ({
    table: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        width: '105px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
});


class GeneralInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                id: {
                    label: "List Id",
                    name: "id",
                    type: "string",
                    path: "id"
                },
                name: {
                    label: "Name",
                    name: "name",
                    type: "string",
                    path: "name",
                    multiLanguage: true
                },
                presentation: {
                    label: "Presentation",
                    name: "presentation",
                    type: "autocomplete",
                    path: "presentation",
                    options: [
                        {label: 'Grid', value: 'grid'},
                        {label: 'Chart', value: 'chart'}
                    ]
                },
                refreshTime: {
                    label: "Refresh Time",
                    name: 'refreshTime',
                    type: 'number',
                    path: 'refreshTime'
                },
                filterAtStart: {
                    name: 'filterAtStart',
                    type: 'switch',
                    path: 'filterAtStart'
                },
                transposeData: {
                    name: 'transposeData',
                    type: 'switch',
                    path: 'transposeData'
                },
                userCustomization: {
                    name: 'userCustomization',
                    type: 'switch',
                    path: 'userCustomization'
                },
                application: {
                    name: 'application',
                    type: 'suggestions',
                    path: 'application'
                }
            }
        }
    }

    render() {
        const {classes, data, generalInfoChange, generalInfoChangeAutoComplete} = this.props;
        const {fields} = this.state;
        return (
            <>
                <>
                    <table className={classes.table}>
                        <tbody>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.id.label}</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.id}
                                           onChange={generalInfoChange}
                                           path={fields.id.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.name.label}</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.name}
                                           onChange={generalInfoChange}
                                           path={fields.name.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.refreshTime.label}</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.refreshTime}
                                           onChange={generalInfoChange}
                                           path={fields.refreshTime.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Presentation</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.presentation}
                                           onChangeAutoComplete={generalInfoChangeAutoComplete}
                                           path={fields.presentation.path}
                                           options={fields.presentation.options}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Filter at start</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.filterAtStart}
                                           onChange={generalInfoChange}
                                           path={fields.filterAtStart.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Transpose Data</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.transposeData}
                                           onChange={generalInfoChange}
                                           path={fields.transposeData.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>User Customization</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.userCustomization}
                                           onChange={generalInfoChange}
                                           path={fields.userCustomization.path}
                                           values={data}/>
                            </td>
                        </tr>
                        <tr>
                            <td className={classes.tableCellLabel}>Application</td>
                            <td className={classes.tableCell}>
                                <TypeEntity
                                    field={{
                                        name: 'application',
                                        entity: 'application',
                                        path: `${fields.application.path}`,
                                        isArray: true
                                    }}
                                    setValue={generalInfoChangeAutoComplete}
                                    fieldStyles={{withoutStyles: true, fullWidth: true}}
                                    dropdownStyles={{width: 300}}
                                    values={data}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </>
            </>
        );
    }
}


export default withStyles(styles)(ListDesignerHoc(GeneralInformation));